module.exports = __webpack_public_path__ + "img/73u_icon.cec87857.png";